import { compose, equals, map, prop, propOr } from 'ramda';
import { filterFalsy } from 'yafrpl/arrays';

import { compact } from '../../../helpers/compact';
import { DocumentType } from '../../../types/document';
import { FILTER, MENU } from '../../../types/filters';
import { toImageFromProp } from '../fields/image';
import { toTextFromProp } from '../fields/text';
import { video } from '../partials/video';
import { deprecatedPageEntity } from './internal';

/**
 * @typedef  {Object} PrismicGroupHistory
 */

/**
 * @typedef {DocumentSchema} GroupHistorySchema
 */

const years = compose(
  filterFalsy,
  map(
    ({ primary, slice_type }) =>
      equals('year', slice_type) &&
      compact({
        id: prop('year', primary),
        title: toTextFromProp('title', primary),
        title2: toTextFromProp('title2', primary),
        subtitle: toTextFromProp('subtitle', primary),
        text: prop('text', primary),
        image: toImageFromProp('image', primary),
        cta: video(primary),
      })
  ),
  propOr([], 'slices')
);

/**
 * Transform the given input into objects
 *
 * @param  {PrismicGroupHistory} data
 * @return {GroupHistorySchema}
 */
const processGroupHistory = (data) =>
  compact({
    uid: DocumentType.GROUP_HISTORY,
    type: DocumentType.GROUP_HISTORY,
    introduction: prop('introduction', data),
    chapeau: prop('chapeau', data),
    body: years(data),
    filters: {
      [FILTER.MENU]: MENU.IDENTITY,
    },
  });

/**
 * Normalizr schema representing a about-us page
 */
export const GroupHistory = deprecatedPageEntity(DocumentType.GROUP_HISTORY, {
  processStrategy: (entity) => ({
    ...processGroupHistory(prop('data', entity)),
  }),
});
